import { z } from 'zod';

/**
 * AI Job Schemas
 * AI job execution, status tracking, and result management
 */

// === AI Job Value Objects ===

export const AIJobIdSchema = z.string().min(1, {
  message: "AI Job ID cannot be empty"
});

export const AIPromptSchema = z.string()
  .min(1, { message: "AI prompt cannot be empty" })
  .max(10000, { message: "AI prompt must be less than 10000 characters" })
  ;

export const AIModelSchema = z.string()
  .min(1, { message: "AI model name cannot be empty" })
  ;

export const ImageUrlSchema = z.string()
  .url({ message: "Invalid image URL format" })
  .nullable()
  ;

// === AI Job Status Enums ===

export const AIJobStatusSchema = z.enum(['pending', 'processing', 'completed', 'failed'], {
  error: "Invalid AI job status. Must be one of: pending, processing, completed, failed"
});

// Export TypeScript types
export type AIJobId = z.infer<typeof AIJobIdSchema>;
export type AIPrompt = z.infer<typeof AIPromptSchema>;
export type AIModel = z.infer<typeof AIModelSchema>;
export type ImageUrl = z.infer<typeof ImageUrlSchema>;
export type AIJobStatus = z.infer<typeof AIJobStatusSchema>;
